/**
 * Object utility functions
 */
/**
 * Deep copy an object using JSON serialization
 */
export function deepCopy(object) {
    return JSON.parse(JSON.stringify(object));
}
/**
 * Get a nested value from an object using dot notation
 * Examples: getNestedValue(obj, "a.b.c") returns obj.a.b.c
 */
export function getNestedValue(obj, path) {
    // Check if path exists directly in object first
    if (path in obj)
        return obj[path];
    // Otherwise, split by dots and traverse
    return path.split(".").reduce((current, key) => {
        return current === null || current === void 0 ? void 0 : current[key];
    }, obj);
}
/**
 * Set a nested value in an object using dot notation
 * Examples: setNestedValue(obj, "a.b.c", value) sets obj.a.b.c = value
 */
export function setNestedValue(obj, path, value) {
    const keys = path.split(".");
    let current = obj;
    keys.forEach((key, index) => {
        if (index === keys.length - 1) {
            current[key] = value;
        }
        else {
            if (!current[key]) {
                current[key] = {};
            }
            current = current[key];
        }
    });
}
